import React from "react";

const Experience = () => {
    return (
        <div className="min-h-[80vh] pb-10 text-[#6366F1] container mx-auto">
            <h1 className="lg:text-5xl text-2xl pt-8  text-center font-semibold hover:text-red-500">
                Experience
            </h1>
            <h2 className="text-center hover:text-yellow-500 text-4xl mt-5 font-semibold">
                CEO and Founder HMSoftTecH Innovation.
            </h2>
            <h2 className="text-center hover:text-green-500 text-4xl mt-5 font-semibold">
                Programming Field : 6 Years Experience.
            </h2>
            <h2 className="text-center hover:text-orange-500 text-4xl mt-5 font-semibold">
                Job Experience : 1 Month ( Intern ) as a Frontend Developer at INDIA
                (2022 Year )
            </h2>
            <h2 className="text-center hover:text-red-500 text-4xl mt-5 font-semibold">
                Full Stack Developer : 3 Years ( Sydney Australia Remote Job)
            </h2>
            <h2 className="text-center hover:text-purple-500 text-4xl mt-5 font-semibold">
                Python Developer : 2 Years
            </h2>
            <h2 className="text-center hover:text-lime-500 text-4xl mt-5 font-semibold">
                Game Development : 3 Month ( I worked on Game Development for 3 Month
                with Unreal Engine & Blender )
            </h2>
            <h2 className="text-center hover:text-teal-500 text-4xl mt-5 font-semibold">
                Apps Development : I am Learning apps Development Now . Technology (
                React native )
            </h2>
            <h2 className="text-center hover:text-cyan-500 text-4xl mt-5 font-semibold">
                I am Currently Working on Project base .
            </h2>
        </div>
    );
};

export default Experience;
// Experiance 